export const contactFields = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CODE: 'code',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
}
